import React from "react"
import { Tag } from "antd";
import Cookies from "js-cookie";
import moment from "moment";
import { components_data } from "../data";
export const grey_color = "#a1a1a1";
export const black_color = "#000000";
export const red_color = "#f12a46";
export const purple_color = "#aa119d";
export const green_color = "#3c8617";
export const orange_color = "#e77e21";
export const blue_color = "#0842a0";
export const pink_color = "#ec008c";

export const successColor = "#4f9818"; // green
export const warningColor = "#E77E21"; // orage
export const disabledColor = "#999999"; // grey
export const futureColor = "#2c7eb5"; // blue
export const bestsellerColor = "#F12A46"; // red
export const peerColor = "#A52A2A"; // burgandy
export const favColor = "#ffcf17" // yellow
export const highlightColor = "#49b7e0" // lightBlue
export const returnedColor = "#9932cc" // lightBlue

export const trimTrailingChar = (_str, _char) => {
  if (_str.endsWith(_char)) {
    return _str.slice(0, -1);
  } else {
    return _str;
  }
}

export const hasLink = (_s = "") => {
  return (!_s || _s === "" || _s === "/" || _s === "http://" || _s === "https://") ? false : true;
}

export const previewLink = (_path) => {

  if (_path.substr(0, 4) === "http") {
    return _path;
  } else {
    // relative link
    return trimTrailingChar(window.sitesettings.url, "/") + _path;
  }
}
//

// Component Universal
export const tt_start_date = <small>This content will become visible to customers as of <strong>12:00am PST</strong> on the date selected. Also ensure that the VISIBILITY is set to Visible and not Draft.</small>
export const tt_end_date = <small>This content will be hidden to customers as of <strong>11:59pm PST</strong> on the date selected.</small>

// Headline & Paragraph
export const tt_hp_gap = <small>Adjust the space between the headline and paragraph.</small>

// Text Over Image
export const tt_toi_padding_x = <small>Add padding to the left and right of the image.</small>
export const tt_toi_padding_y = <small>Add padding to the top and bottom of the image, therefore extending it.</small>
export const tt_toi_bg_align = <small>Cover has the image width set to the width of the container. Contain will shrink the whole image down to fit inside the container. Initial will display the image at its original size. The top/bottom or left/right of the image may be cropped depending on the selection, but you can use the above PADDING, BG ALIGN, or below BACKGROUND IMAGE MARGINS options to adjust the image crop and placement.</small>
export const tt_toi_bg_margin_t = <small>Top margin.</small>
export const tt_toi_bg_margin_r = <small>Right margin.</small>
export const tt_toi_bg_margin_b = <small>Bottom margin.</small>
export const tt_toi_bg_margin_l = <small>Left margin.</small>
export const tt_toi_border_radius = <small>Apply rounded corners to the TEXT BACKGROUND COLOUR. The higher the value, the rounder the corners.</small>
export const tt_toi_align_left = <small>Left align the text container.</small>
export const tt_toi_align_center = <small>Centre align the text container.</small>
export const tt_toi_align_right = <small>Right align the text container.</small>
export const tt_toi_txt_padding_x = <small>Add padding to the left and right. If there is a TEXT BACKGROUND COLOUR applied, this will extend that background.</small>
export const tt_toi_txt_padding_y = <small>Add padding to the top and bottom. If there is a TEXT BACKGROUND COLOUR applied, this will extend that background.</small>

// Text Over Video
export const tt_tov_bg_video = <small>Upload a short <strong>.mp4</strong> or <strong>.webm</strong> video file that will be muted and its playback looped. Videos must be <strong>h.264</strong> codec for .mp4, or <strong>vp8-9</strong> codec for .webm, and under 3MB in file size. We highly recommend videos to be under 30 seconds, 1920px wide by 1080px tall, do not include audio data (to save on file size), the frame rate 23.98-30fps, and a bit rate under 5000kbps. If you have a longer form video that includes sound, use the <strong>Youtube</strong> component instead.</small>
export const tt_tov_bg_padding_x = <small>Add padding to the left and right of the video.</small>
export const tt_tov_bg_padding_y = <small>Add padding to the top and bottom of the video, therefore extending it.</small>
export const tt_tov_border_radius = <small>Apply rounded corners to the TEXT BACKGROUND COLOUR. The higher the value, the rounder the corners.</small>
export const tt_tov_align_left = <small>Left align the text container.</small>
export const tt_tov_align_center = <small>Centre align the text container.</small>
export const tt_tov_align_right = <small>Right align the text container.</small>
export const tt_tov_txt_padding_x = <small>Add padding to the left and right. If there is a TEXT BACKGROUND COLOUR applied, this will extend that background.</small>
export const tt_tov_txt_padding_y = <small>Add padding to the top and bottom. If there is a TEXT BACKGROUND COLOUR applied, this will extend that background.</small>

// Side By Side
export const tt_sbs_padding_x = <small>Add padding to the left and right of the whole container. If there is a BACKGROUND COLOUR applied, this will extend that background.</small>
export const tt_sbs_padding_y = <small>Add padding to the top and bottom of the whole container. If there is a BACKGROUND COLOUR applied, this will extend that background.</small>
export const tt_sbs_contain = <small>Cover has the image width set to the width of the container. Contain will shrink the whole image down to fit inside the container. Initial will display the image at its original size. The top/bottom or left/right of the image may be cropped depending on the selection, but you can use the above IMAGE WIDTH / HEIGHT options to adjust the image crop and placement.</small>
export const tt_sbs_txt_padding_x = <small>Add padding to the left and right of the text container.</small>
export const tt_sbs_txt_padding_y = <small>Add padding to the top and bottom of the text container.</small>

// Image Grid
export const tt_ig_display = <small>Cover has the image scaled and cropped to fill the container. Contain will fit the whole image inside the container without any cropping. Initial will display the image at its original size, but can crop the width and height to fit the container. Each image container's size can be set using the IMAGE WIDTH / HEIGHT settings</small>
export const tt_ig_gap_x = <small>Adjust the horizontal spacing between images.</small>
export const tt_ig_gap_y = <small>Adjust the vertical spacing between images.</small>
export const tt_ig_padding_x = <small>Add padding to the left and right of the whole container. If there is a BACKGROUND COLOUR applied, this will extend that background.</small>
export const tt_ig_padding_y = <small>Add padding to the top and bottom of the whole container. If there is a BACKGROUND COLOUR applied, this will extend that background.</small>

// Image Carousel
export const tt_ic_display = <small>Cover has the image scaled and cropped to fill the container. Contain will fit the whole image inside the container without any cropping. Initial will display the image at its original size, but can crop the width and height to fit the container. Each image container's size can be set using the IMAGE WIDTH / HEIGHT settings</small>
export const tt_ic_align = <small>If you have set a constrained width for images using the WIDTH / HEIGHT setting below, then you can align the resulting container to the left, centre, or right. If WIDTH is set to 0, then the full container width will be filled, and these alignment options will do nothing</small>
export const tt_ic_padding_x = <small>Add padding to the left and right of the whole container. If there is a BACKGROUND COLOUR applied, this will extend that background.</small>
export const tt_ic_padding_y = <small>Add padding to the top and bottom of the whole container. If there is a BACKGROUND COLOUR applied, this will extend that background.</small>
export const tt_ic_width = <small>If set to 0, the entire container width is used.</small>
export const tt_ic_animate = <small>Check this option to automatically scroll or fade between the images. Use the seconds setting to set how long an image remains before switching.</small>

// Youtube
export const tt_yt_url = <small>Copy the URL of the Youtube/Vimeo video, either from the browser address bar, or from the Youtube/Vimeo Share link, and paste it here.</small>
export const tt_yt_padding_x = <small>Add padding to the left and right of the whole container. If there is a BACKGROUND COLOUR applied, this will extend that background.</small>
export const tt_yt_padding_y = <small>Add padding to the top and bottom of the whole container. If there is a BACKGROUND COLOUR applied, this will extend that background.</small>

// Product Slider
export const tt_ps_list = <small>Create lists on Biz first, then select them here. Updates to lists on Biz will also update them here. You can also use a Browse Filter Preset to populate titles, so the products dynamically update based on the filters within the preset.</small>
export const tt_ps_padding_x = <small>Add padding to the left and right of the whole container. If there is a BACKGROUND COLOUR applied, this will extend that background.</small>
export const tt_ps_padding_y = <small>Add padding to the top and bottom of the whole container. If there is a BACKGROUND COLOUR applied, this will extend that background.</small>
export const tt_ps_gap = <small>Adjust the space between products.</small>

// Product Grid
export const tt_pg_list = <small>Create lists on Biz first, then select them here. Updates to lists on Biz will also update them here. You can also use a Browse Filter Preset to populate titles, so the products dynamically update based on the filters within the preset.</small>
export const tt_pg_padding_x = <small>Add padding to the left and right of the whole container. If there is a BACKGROUND COLOUR applied, this will extend that background.</small>
export const tt_pg_padding_y = <small>Add padding to the top and bottom of the whole container. If there is a BACKGROUND COLOUR applied, this will extend that background.</small>
export const tt_pg_gap_x = <small>Adjust the horizontal space between products.</small>
export const tt_pg_gap_y = <small>Adjust the vertical space between products.</small>

// Accordion 
export const tt_ac_ghost = <small>Ghost mode removes the background and border from the accordion, making it appear transparent and blend with the page. Only the text and icons will be visible.</small>
export const tt_ac_accordion = <small>Accordion mode allows only one panel to be expanded at a time. When a new panel is opened, any previously open panel will automatically collapse.</small>

// Single Title Feature
export const tt_stf_padding_x = <small>Add padding to the left and right of the whole container. If there is a BACKGROUND COLOUR applied, this will extend that background.</small>
export const tt_stf_padding_y = <small>Add padding to the top and bottom of the whole container. If there is a BACKGROUND COLOUR applied, this will extend that background.</small>
export const tt_stf_txt_padding_x = <small>Add padding to the left and right of the text container.</small>
export const tt_stf_txt_padding_y = <small>Add padding to the top and bottom of the text container.</small>

// Events Calendar
export const tt_evt_padding_x = <small>Add padding to the left and right of the whole container. If there is a BACKGROUND COLOUR applied, this will extend that background.</small>
export const tt_evt_padding_y = <small>Add padding to the top and bottom of the whole container. If there is a BACKGROUND COLOUR applied, this will extend that background.</small>

// Events Calendar / Upcoming
export const tt_evu_padding_x = <small>Add padding to the left and right of the whole container. If there is a BACKGROUND COLOUR applied, this will extend that background.</small>
export const tt_evu_padding_y = <small>Add padding to the top and bottom of the whole container. If there is a BACKGROUND COLOUR applied, this will extend that background.</small>

// Single Event Feature
export const tt_buy_titles = <small>If an event has tickets enabled, the label for that button is specified within the event listing itself.</small>
export const tt_sef_padding_x = <small>Add padding to the left and right of the whole container. If there is a BACKGROUND COLOUR applied, this will extend that background.</small>
export const tt_sef_padding_y = <small>Add padding to the top and bottom of the whole container. If there is a BACKGROUND COLOUR applied, this will extend that background.</small>

// Above Searchbar Notice
export const tt_asn_padding_x = <small>Add padding to the left and right of the whole container. If there is a BACKGROUND COLOUR applied, this will extend that background.</small>
export const tt_asn_padding_y = <small>Add padding to the top and bottom of the whole container. If there is a BACKGROUND COLOUR applied, this will extend that background.</small>

// Popup Notice
export const tt_pun_border_radius = <small>Apply rounded corners to the pop up box. The higher the value, the rounder the corners.</small>
export const tt_pun_padding_x = <small>Add padding to the left and right of the internal text container.</small>
export const tt_pun_padding_y = <small>Add padding to the top and bottom of the internal text container.</small>
export const tt_pun_gap = <small>Adjust the spacing between the HEADLINE and PARAGRAPH text.</small>

// Giftcard Image / Add to Cart
export const tt_gci_padding_x = <small>Add padding to the left and right of the whole container. If there is a BACKGROUND COLOUR applied, this will extend that background.</small>;
export const tt_gci_padding_y = <small>Add padding to the top and bottom of the whole container. If there is a BACKGROUND COLOUR applied, this will extend that background.</small>
export const tt_gci_gap = <small>Adjust the spacing between the gift card image and the text/button.</small>
export const tt_gci_radius = <small>Apply rounded corners to the gift card image. The higher the value, the rounder the corners. The default is 15, which is how Bookmanager's plastic cards are trimmed.</small>

// Gift card Balanace Checker
export const tt_gbc_padding_x = <small>Add padding to the left and right of the whole container. If there is a BACKGROUND COLOUR applied, this will extend that background.</small>
export const tt_gbc_padding_y = <small>Add padding to the top and bottom of the whole container. If there is a BACKGROUND COLOUR applied, this will extend that background.</small>

// Menu
export const tt_menu_filter = <small>Filter the list of menus based on status.</small>;
export const tt_menu_visible = <small>This menu / page is visible to customers.</small>;
export const tt_menu_draft = <small>This menu / page is in draft mode, and is not visible to customers, even with a direct link.</small>;
export const tt_menu_unlisted = <small>This menu / page is unlisted, and is not visible in the navigation menu, but can be accessed by customers via a link. Use the Link button to copy the URL for this page.</small>;
export const tt_menu_link = <small>Open URL to this page in a new tab</small>;

// Content
export const tt_content_edit = <small>Edit</small>;
export const tt_content_filter = <small>Filter the list of content based on status.</small>;
export const tt_content_visible = <small>This content is visible to customers.</small>;
export const tt_content_draft = <small>This content is in draft mode, and is not visible to customers.</small>;
export const tt_content_scheduled = <small>This content is scheduled to </small>
export const tt_content_expired = <small>This content was scheduled but expired on </small>

// Buttons
export const tt_button_edit = <small>Edit the button name</small>;
export const tt_button_inital = <small>How the button initially looks</small>;
export const tt_button_hover = <small>How the button looks when being hovered over or focused. Giving the button a subtle difference in styling when hovered or focused lets users know this is a button, and can assist those exclusively using their keyboard to navigate.</small>


// Links
export const tt_links_edit = <small>Edit the link style name</small>;
export const tt_links_inital = <small>How the links initially looks</small>;
export const tt_links_hover = <small>How the link looks when being hovered over or focused. Giving the link a subtle difference in styling when hovered or focused lets users know this is a link, and can assist those exclusively using their keyboard to navigate.</small>



//Presets tab
export const tt_preset_edit = <small>Edit the name of the preset</small>;

// Generic
export const tt_font_size = <small>Text size in pixels</small>;
export const tt_letter_spacing = <small>The space between letters. Negative values squish letters together, positive values push letters apart. 0 is default.</small>
export const tt_line_height = <small>The space between lines of text when they break onto a new line. 100% is equal to the height of the text. 150% is recommended for paragraph text, and 120% for headline text.</small>
export const tt_margin_x = <small>Add a margin of space to the left and right. This is applied after padding, and does not extend the background colour.</small>
export const tt_margin_y = <small>Add a margin of space to the top and bottom. This is applied after padding, and does not extend the background colour.</small>
export const tt_padding_x = <small>Add padding to the left and right. If there is a BACKGROUND COLOUR applied, this will extend that colour.</small>
export const tt_padding_y = <small>Add padding to the top and bottom. If there is a BACKGROUND COLOUR applied, this will extend that colour.</small>
export const tt_shadow_x = <small>Adjust the horizontal offset of the shadow. Negative values move the shadow left, positive values move the shadow right. 0 positions the shadow in the centre of the object.</small>
export const tt_shadow_y = <small>Adjust the vertical offset of the shadow. Negative values move the shadow up, positive values move the shadow down. 0 positions the shadow in the middle of the object.</small>
export const tt_shadow_blur = <small>Adjust the edge blur of the shadow. 0 means no blur (a shadow with a solid line for edges). Positive values only.</small>
export const tt_shadow_spread = <small>Positive values will cause the shadow to expand and grow bigger, negative values will cause the shadow to shrink.</small>
export const tt_border_radius = <small>Apply rounded corners to the border or background colour. The higher the value, the more round the corners will be.</small>
export const tt_border_size = <small>Adjust the thickness of the border.</small>
export const tt_border_enable = <small>Enable/disable the border on the </small>

// Templates
export const tt_template_edit = <small>Edit the template name</small>
export const tt_template_active = <small>This template is activated and live on your Webstore</small>
export const tt_template_inactive = <small>Activate this template on your live Webstore</small>

// Panel
export const tt_global_banner = <small>Content placed in the global banner will appear on all site pages / menus, including the cart and Browse area.</small>
export const tt_phone_view = <small>Phone preview <em>(375px wide)</em></small>;
export const tt_tablet_preview = <small>Tablet preview <em>(768px wide)</em></small>;
export const tt_monitor_preview = <small>Monitor preview <em>(1248px wide or larger)</em></small>;

export const tt_color_reset = <small>Reset this colour back to its default value.</small>
export const tt_color_delete = <small>Delete the colour. Some colours cannot be deleted, but they can be renamed or reset to default. You can only delete the last colour on the list because each colour's position on the list is functionally important to how Templates work.</small>

export const tt_gradient_reset = <small>Reset this gradient back to its default value.</small>
export const tt_gradient_delete = <small>Delete the gradient. Some gradient cannot be deleted, but they can be renamed or reset to default. You can only delete the last gradient on the list because each gradient's position on the list is functionally important to how Templates work.</small>

export const tt_link_reset = <small>Reset this link back to its default value.</small>
export const tt_link_delete = <small>Delete the link style. Some links cannot be deleted, but they can be renamed or reset to default. You can only delete the last link on the list because each link's position on the list is functionally important to how Templates work.</small>
export const tt_link_duplicate = <small>Duplicate the link style. This is helpful if you wish to create a new link style that is only slightly different than an existing one.</small>

export const tt_button_reset = <small>Reset this button back to its default value.</small>
export const tt_button_delete = <small>Delete the button. Some buttons cannot be deleted, but they can be renamed or reset to default. You can only delete the last button on the list because each button's position on the list is functionally important to how Templates work.</small>
export const tt_button_duplicate = <small>Duplicate the button. This is helpful if you wish to create a new button that is only slightly different than an existing one.</small>

export const tt_preset_reset = <small>Reset this preset back to its default value.</small>
export const tt_preset_delete = <small>Delete the preset. Some presets cannot be deleted, but they can be renamed or reset to default. You can only delete the last preset on the list because each preset's position on the list is functionally important to how Templates work.</small>
export const tt_preset_duplicate = <small>Duplicate the preset. This is helpful if you wish to create a new preset that is only slightly different than an existing one.</small>

export const tt_font_reset = <small>Reset this font back to its default value.</small>
export const tt_font_delete = <small>Delete the font. Some fonts cannot be deleted, but they can be renamed or reset to default. You can only delete the last font on the list because each font's position on the list is functionally important to how Templates work.</small>

export const tt_not_activated = <small>Pages / Menus that have not been activated will not display the content you see here on the Webstore Designer, and instead display the content placed using the old admin site. <div className="shim" /><div className="shim" />Use the blue <strong>Activate</strong> button found on the upper right corner of an unactivated Menu to display your new content once it's ready.</small>

export const tt_name_block_warning = "Please name content block:";

export const deep = (obj, keys, value) => {
  if (keys.length === 0) {
    return value;
  }
  const keyToUpdate = keys[0];
  if (keys.length === 1) {
    return { ...obj, [keyToUpdate]: value };
  }
  return {
    ...obj,
    [keyToUpdate]: deep(obj[keyToUpdate], keys.slice(1), value),
  };
}


export const colorInfo = (colorObj) => {
  const { red, green, blue, alpha } = colorObj;
  const alphaPercent = Math.round(alpha * 100);
  const rgbHex = ((1 << 24) | (red << 16) | (green << 8) | blue).toString(16).slice(1).toUpperCase();
  const hexColor = `#${rgbHex}`;
  return `${hexColor} ${alphaPercent}% Opaque`;
}

export const prettyTime = (_str) => {
  const time = moment(_str, 'HH:mm:ss')
  if (time.isValid()) {
    return time.format('h:mm A');
  }
  else {
    return "";
  }
};

export const canDeleteRecord = (templates, current_template, id, _key = "texts") => {


  if (id === 0) { return; }
  if (!current_template.hasOwnProperty("id")) { return false; }
  let is_last = current_template[_key][current_template[_key].length - 1].id === id;
  if (!is_last) { return false; }
  if (current_template[_key].length === 1) { return false; }

  let others = templates.filter(item => item.id !== current_template.id);
  others.forEach(item => {
    if (item[_key].length >= current_template[_key].length) {
      if (item[_key].length === current_template[_key].length && item[_key][item[_key].length - 1].synthetic) {
        is_last = true;
      } else {
        is_last = false;
      }
    }
  })
  return is_last;
}


export const applyDrag = (arr, dragResult) => {
  const { removedIndex, addedIndex, payload } = dragResult;
  if (removedIndex === null && addedIndex === null) return arr;

  const result = [...arr];
  let itemToAdd = payload;

  if (removedIndex !== null) {
    itemToAdd = result.splice(removedIndex, 1)[0];
  }

  if (addedIndex !== null) {
    result.splice(addedIndex, 0, itemToAdd);
  }

  return result;
};


function rgbToHsl(r, g, b) {
  r /= 255;
  g /= 255;
  b /= 255;

  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  let h, s;
  const l = (max + min) / 2;

  if (max === min) {
    h = s = 0;
  } else {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r: h = (g - b) / d + (g < b ? 6 : 0); break;
      case g: h = (b - r) / d + 2; break;
      case b: h = (r - g) / d + 4; break;
    }
    h /= 6;
  }

  return [h, s, l];
}

export const getLightness = (rgbColor = "") => {
  console.log(rgbColor)
  const [r, g, b] = rgbColor.match(/\d+/g).map(Number);
  const [, , l] = rgbToHsl(r, g, b);
  return l;
}


export const bmDate = (_date) => {

  if (moment(_date).format("D").length === 1) {
    return moment(_date).format("MMM D-YY")
  } else {
    return moment(_date).format("MMMDD-YY")
  }
}

export const getFlag = (_country) => {
  let flag = "https://bookmanager.com/i/CA.png"
  switch (_country) {
    case "Canada":
      flag = "CA"
      break;
    case "United Kingdom":
      flag = "CA"
      break;
    case "USA":
      flag = "US"
      break;
    default:
      flag = "CA"
      break;
  }
  return "https://bookmanager.com/i/" + flag + ".png";
}

export const cacheBuster = () => {

  return "?cache=" + window.cache;

}



export const getComponentLabel = (_key) => {

  const ret = components_data.components.find(item => item.key === _key);

  if (ret) {
    return ret?.label;
  } else {
    return _key;
  }

}


export const bytesToSize = (bytes) => {
  let sizes = ['', 'k', 'm', 'gb', 'tb'];
  if (bytes === 0) return '0 Byte';
  let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
  return Math.round(bytes / Math.pow(1024, i), 2) + '' + sizes[i];
}

export const addCommas = (_num) => {
  return _num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

// React likes unique id's for listed elements so it knows what to draw / update
export const addKeys = (_arr, _key = false) => {
  return (_arr.map((item) => {

    if (_key) {
      item["key"] = item[_key];
    } else {
      item["key"] = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);;
    }

    return item;
  }))
}

export const makeKey = () => {
  return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);;
}

export const ucfirst = (string) => {

  if (string.includes("-")) {
    string = string.split("-");
    string = string.map(item => ucfirst(item));
    return string.join(" ");
  }


  if (string.includes("_")) {
    string = string.split("_");
    string = string.map(item => ucfirst(item));
    return string.join(" ");
  }

  return (string) ? string.charAt(0).toUpperCase() + string.slice(1) : "";
}


export const parseAuthors = (_authors) => {
  if (!_authors || _authors.length === 0) { return "" }
  return _authors.map((_author, index) => {
    return (<span style={{ "color": "#1581e9", "fontSize": "14px" }} key={index}>{_author}{(index !== _authors.length - 1) ? ", " : ""} </span>);
  });
}

export const parseSubjectsPlain = (_subjects) => {
  if (!_subjects || _subjects.length === 0) { return "" }
  return _subjects.map((_subject, index) => {
    if (_subject.sub_labels.length > 0) {
      return (<span key={index}>{_subject.subject} / {_subject.sub_labels.map((_sub) => { return (_sub.label) }).join(" / ")}{(index !== _subject.sub_labels.length && ",")} </span>)
    } else {
      return (<span key={index}>{_subject.subject}</span>);
    }
  })
}


export const parseSubjectsWeird = (_subjects, _limit = 30) => {
  if (!_subjects || _subjects.length === 0) { return "" }
  let ret = "";
  // limit to first
  _subjects = [_subjects[0]];


  return _subjects.map((_subject, index) => {
    if (_subject.sub_labels.length > 0) {
      // limit to first sub
      if (_subject.sub_labels.length > 0) {
        ret += _subject.sub_labels[0].bisac.substr(0, 3) + ": " + _subject.sub_labels[0].label;
      }

      return <>{ret}</>
    } else {
      return (<>{_subject.subject.substring(0, _limit)}</>);
    }
  })
}




export const parseSubjects = (_subjects) => {
  if (!_subjects || _subjects.length === 0) { return "" }
  return _subjects.map((_subject, index) => {
    if (_subject.sub_labels.length > 0) {
      return (<div key={index}><span className="c" style={{ "fontWeight": "600" }}>{_subject.subject}</span> / {_subject.sub_labels.map((_sub) => { return (_sub.label) }).join(" / ")}
        {((index + 1) !== _subjects.length && ", ")}
      </div>)
    } else {
      return (<div key={index} className="c" style={{ "fontWeight": "600" }}>{_subject.subject}</div>);
    }
  })
}

export const parseSubjectsList = (_subjects) => {
  if (!_subjects || _subjects.length === 0) { return "" }
  return _subjects.map((_subject, index) => {
    if (_subject.sub_labels.length > 0) {
      // has sub
      return (<span key={index}><strong className="c">{_subject.subject}</strong> <br /> {_subject.sub_labels.map((_sub, i) => { return ((_sub.label) ? <span key={i}>{_sub.label}<br /></span> : <></>) })}</span>)
    } else {
      return (<span key={index}><strong className="c">{_subject.subject}</strong><br /></span>);
    }
  })
}





export const parseRank = (_rank) => {
  if (!_rank) { return "" }
  if (_rank.hasOwnProperty('bestseller')) {
    return (<span style={{ "color": bestsellerColor }}>{"#" + _rank.bestseller + " in bestsellers"}</span>);
  }
  if (_rank.hasOwnProperty('future')) {
    return (<span style={{ "color": futureColor }}>{"#" + _rank.future + " in future releases"}</span>);
  }
  return "";
}


export const getQuantity = (_isbn, _cart) => {


  let find = _cart.find((item => item.isbn === _isbn));

  if (!find) {
    return [];
  }


  return find.suppliers.map((itm => {
    return {
      quantity: itm.quantity,
      supplier: itm.location
    }
  }))
}

export const drawQuantity = (_isbn, _cart) => {
  let btn_arr = getQuantity(_isbn, _cart)
  let _color = (btn_arr.length > 0) ? "#4f9818" : "#aaaaaa"
  return (
    <Tag style={{ "lineHeight": "16px", "cursor": "pointer", "textAlign": "center", "marginRight": "0px" }} color={_color}>
      {((btn_arr.length === 0) && "Order")}
      {btn_arr.map((itm, index) => {
        return <span key={index}>{itm.quantity} - {itm.supplier}<br /></span>
      })}
    </Tag>
  )
}


export const getGroups = (_stores = true) => {

  const stores = window.sitesettings.stores.map((item, index) => { return index.toString() })
  const groups = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"];

  if (stores.length > 1) {
    return stores.concat(groups)
  } else {
    return groups;
  }

}


export const pathToObj = (_path, _map) => {
  let _arr = _path.split("/");
  let _keys = Object.keys(_map).map(item => _map[item]);
  let _obj = {};

  _keys.forEach(_key => {
    _obj[_key] = "";
  })

  for (let i = 0; i < _arr.length; i++) {
    if (i < (_arr.length - 1)) {
      if (_obj.hasOwnProperty(_arr[i])) {
        _obj[_arr[i]] = _arr[(i + 1)];
      }
    }
  }

  let _ret = {}
  Object.keys(_map).forEach(_key => {
    if (_obj.hasOwnProperty(_map[_key])) {
      _ret[_key] = _obj[_map[_key]];
    }
  })

  return _ret;




}

export const objToPath = (_obj, _map) => {
  let _path = "filter";
  Object.keys(_obj).forEach(_key => {
    if (_obj[_key]) {
      _path += "/" + _map[_key] + "/" + _obj[_key];
    }
  })
  return _path;
}






export const objectToPath = (_obj, firstpage = false) => {
  let location = "/filter";

  // remove sub-subjects if there is no top-level subject
  if (_obj.hasOwnProperty("c") && _obj.c.length === 0) {
    if (_obj.hasOwnProperty("d") && _obj.d.length > 0) {
      delete _obj.d;
    }
  }

  if (_obj.hasOwnProperty("c") && _obj.hasOwnProperty("d")) {
    for (let i = 0; i < _obj.d.length; i++) {
      if (!_obj.c.includes(_obj.d[i].substr(0, 3))) {
        _obj.d = _obj.d.filter(itm => itm !== _obj.d[i]);
      }
    }
  }

  Object.keys(_obj).forEach((key) => {

    if (Array.isArray(_obj[key]) && _obj[key].includes("AND")) {
      if (_obj[key].length < 3) {
        // strip and
        _obj[key] = _obj[key].filter(itm => itm !== "AND");
      }
    }

    location += (Array.isArray(_obj[key]) && _obj[key].length > 0) ? "/" + key.toString() + "/" + _obj[key].join("/") : "";
  })
  //offset

  if (firstpage) {
    _obj.o = 0;
  }

  if (_obj.hasOwnProperty("o") && _obj.o !== 0) {
    location += "/o/" + _obj.o.toString();
  }

  //limit
  if (_obj.hasOwnProperty("l") && _obj.l !== 20) {
    location += "/l/" + _obj.l.toString();
  }

  //sort
  if (_obj.hasOwnProperty("v") && _obj.v !== "") {
    location += "/v/" + encodeURI(_obj.v)
  }
  //term
  if (_obj.hasOwnProperty("t") && _obj.t !== "") {
    location += "/t/" + encodeURI(_obj.t)
  }
  //key type
  if (_obj.hasOwnProperty("k") && _obj.k !== "") {
    location += "/k/" + encodeURI(_obj.k)
  }


  return location;
}


export const getFilterSet = (_key) => {
  let _saved = Cookies.get("filtersets");
  if (!_saved) return false;
  _saved = JSON.parse(_saved);
  if (_saved.hasOwnProperty(_key)) {
    return JSON.parse(_saved[_key]);
  } else {
    return false;
  }
}

export const saveFilterSet = (_key, _value) => {

  let _saved = Cookies.get("filtersets");
  let filtersets = {}
  // no memory at all - save first
  if (!_saved) {
    filtersets = {
      [_key]: JSON.stringify(_value)
    }
    Cookies.set("filtersets", JSON.stringify(filtersets))
    return filtersets[_key];
  }

  _saved = JSON.parse(_saved);
  // memory exists, no key 
  _saved[_key] = JSON.stringify(_value);
  Cookies.set("filtersets", JSON.stringify(_saved))
  return _saved[_key];
}




export const getMemory = (_key) => {
  let _saved = Cookies.get("memory");
  if (!_saved) return [];
  _saved = JSON.parse(_saved);
  if (_saved.hasOwnProperty(_key)) {
    return _saved[_key];
  } else {
    return []
  }
}

export const saveMemory = (_key, _value) => {
  let _saved = Cookies.get("memory");
  let memory = {}
  // no memory at all - save first
  if (!_saved) {
    memory = {
      [_key]: [_value]
    }
    Cookies.set("memory", JSON.stringify(memory))
    return memory[_key];
  }

  _saved = JSON.parse(_saved);
  // memory exists, no key 
  if (!_saved.hasOwnProperty(_key)) {
    _saved[_key] = [_value]
    Cookies.set("memory", JSON.stringify(_saved))
    return _saved[_key];
  }

  if (_saved[_key].includes(_value)) {
    // not unique, put it at the top
    _saved[_key] = _saved[_key].filter(item => item !== _value);
    _saved[_key].unshift(_value);
    Cookies.set("memory", JSON.stringify(_saved));
    return _saved[_key];
  }

  _saved[_key].unshift(_value);
  _saved[_key] = _saved[_key].slice(0, 5); // limit to 5
  Cookies.set("memory", JSON.stringify(_saved));
  return _saved[_key];

}


export const getFilterCount = (_path) => {

  let obj = pathToObject(_path);
  let count = 0;

  Object.keys(obj).forEach(key => {
    if (Array.isArray(obj[key])) {
      count += obj[key].length;
    }
  })

  return count;

}

function isLetter(c) {
  return c.toLowerCase() !== c.toUpperCase();
}

export const pathToObject = (_path, _save = "") => {


  let returnObject = {
    o: 0, // offset
    l: 20, // limit
    t: "", // term
    k: "", // type
    v: "",
  }

  if (_save) {
    let _lm = parseInt(Cookies.get(_save));
    if (!isNaN(_lm)) {
      returnObject.l = _lm;
    }
  }

  let startIndex = _path.search(/filter/i);
  let p = _path.substr(startIndex, _path.length);
  let split = p.split("/");
  let key;
  let ka = ["b"];
  for (let i = 0; i < split.length; i++) {
    if (split[i].length === 1 && isLetter(split[i])) {
      key = split[i];
    } else {
      if (!returnObject.hasOwnProperty(key)) {
        if (key) {
          returnObject[key] = [];
        } else {
          continue;
        }
      }
      if (Array.isArray(returnObject[key])) {

        returnObject[key] = [...returnObject[key], split[i]];
      } else {
        if (key === "o" || key === "l") {

          returnObject[key] = parseInt(split[i]);
        } else {
          returnObject[key] = split[i];
        }
      }
      (ka.indexOf(key) === -1 && ka.push(key));
    }
  }

  return returnObject;
}


export const pluralize = (count, noun, suffix = 's') => {
  return (count === 1) ? noun : noun + suffix;
}


export const adjustOpacity = (hexCode, amount) => {
  let hex = hexCode.replace('#', '');

  if (hex.length === 3) {
    hex = `${hex[0]}${hex[0]}${hex[1]}${hex[1]}${hex[2]}${hex[2]}`;
  }

  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  return `rgba(${r},${g},${b},${amount / 100})`;
};

export const adjustColor = (col, amt) => {

  var usePound = false;

  if (col[0] === "#") {
    col = col.slice(1);
    usePound = true;
  }

  var num = parseInt(col, 16);

  var r = (num >> 16) + amt;

  if (r > 255) r = 255;
  else if (r < 0) r = 0;

  var b = ((num >> 8) & 0x00FF) + amt;

  if (b > 255) b = 255;
  else if (b < 0) b = 0;

  var g = (num & 0x0000FF) + amt;

  if (g > 255) g = 255;
  else if (g < 0) g = 0;

  return (usePound ? "#" : "") + (g | (b << 8) | (r << 16)).toString(16);

}

export const rgbaToHex = (rgba) => {
  // Parse the RGBA color components
  const components = rgba.substring(rgba.indexOf("(") + 1, rgba.lastIndexOf(")")).split(",");
  const red = parseInt(components[0]);
  const green = parseInt(components[1]);
  const blue = parseInt(components[2]);
  const alpha = Math.round(parseFloat(components[3]) * 255);

  // Convert the color components to hex format
  const redHex = red.toString(16).padStart(2, "0");
  const greenHex = green.toString(16).padStart(2, "0");
  const blueHex = blue.toString(16).padStart(2, "0");
  const alphaHex = alpha.toString(16).padStart(2, "0");

  // Construct the hex color value
  let hex = "#" + redHex + greenHex + blueHex;

  // Only add alpha if required
  if (alpha !== 255) {
    hex += alphaHex;
  }

  return hex.toUpperCase();
}
